import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/share';
/**
 * Singleton service, injected at app level
 */
var LoadingService = (function () {
    function LoadingService() {
        var _this = this;
        this.loading$ = new Observable(function (observer) { return _this._observer = observer; }).share();
    }
    LoadingService.prototype.toggleLoadingIndicator = function (name) {
        if (this._observer) {
            this._observer.next(name);
        }
    };
    return LoadingService;
}());
export { LoadingService };
//# sourceMappingURL=loading.service.js.map